import React, { useState } from "react";
import { Search, Users } from "lucide-react";
import api from "@/lib/api";
import { UserBadge } from "@/components/UserBadge";

export default function Members() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  const [busy, setBusy] = useState(false);

  const search = async (e) => {
    e?.preventDefault?.();
    if (!q.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.get("/users/search", { params: { q: q.trim() } });
      setResults(data);
    } catch { setResults([]); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="members-page">
      <div className="text-center mb-8">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#E50914] font-bold inline-flex items-center gap-1.5"><Users className="w-3 h-3" /> Community</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Find a member</h1>
        <p className="text-zinc-400 mt-2 text-sm">Search by exact username. Privacy first — no browsing all members.</p>
      </div>

      <form onSubmit={search} className="relative max-w-lg mx-auto mb-8">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
        <input data-testid="members-search"
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Type an exact username..."
          className="w-full pl-10 pr-24 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-[#E50914]/50 text-sm outline-none" />
        <button type="submit" disabled={busy || !q.trim()} className="absolute right-1.5 top-1/2 -translate-y-1/2 px-4 py-2 rounded-lg bg-[#E50914] hover:bg-[#F6121D] text-white text-xs font-bold disabled:opacity-50">
          {busy ? "..." : "Search"}
        </button>
      </form>

      {results != null && (
        <div className="glass rounded-2xl p-5" data-testid="members-results">
          {results.length === 0 ? (
            <p className="text-center text-zinc-500 text-sm py-6">No member found with that exact name.</p>
          ) : (
            <div className="space-y-3">
              {results.map((u) => (
                <div key={u.id} className="flex items-center justify-between gap-3 p-3 rounded-xl bg-white/5 border border-white/5">
                  <UserBadge user={u} size="lg" />
                  <span className="text-xs text-zinc-400 font-bold">{u.xp} XP</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
